export default __webpack_public_path__ + "static/media/502.1dc2f557.png";